export const blockIconsNotificationWifiOff = (
	<span className='material-symbols-outlined'>wifi_off</span>
);
